import React, {useState} from 'react';
import PodCardList from "./pod-card-list";

const PodDashboard = () => {
    const [selectedPod, setSelectedPod] = useState(null);

    return (
        <>

            <div className="page-container dashboard-container">

                <div className="items-center justify-start p-8 mb-28 w-full">
                    <div className="flex justify-start m-2 pb-2">
                        <div className="text-xl">
                            Pods
                        </div>
                    </div>

                    <PodCardList
                        selectedPod={selectedPod}
                        setSelectedPod={setSelectedPod}/>

                </div>

            </div>

        </>
    )
}

export default PodDashboard
